import { ButtonHTMLAttributes } from 'react';

import { ReactComponent as ErrorSvg } from '../../assets/Error.svg';
import styled from '../../lib/theme';

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: ${({ theme }) => theme.backgroundColor || 'white'};

  .k-bubble {
    background-color: ${({ theme }) => theme.agentBubbleBackgroundColor || theme.primaryAccentColor};
    border-color: transparent;
  }

  .k-typing-indicator {
    color: ${({ theme }) => theme.agentBubbleTextColor || theme.primaryAccentTextColor}};
  }
`;

interface ILabelProps {
  bold?: boolean;
}

export const Label = styled('div')<ILabelProps>`
  font-size: 1.6rem;
  font-weight: ${(props: ILabelProps) => (props.bold ? '800' : '400')};
`;

export const ChatBody = styled('div')`
  height: calc(100% - 62px);
  position: relative;
`;

interface IButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  filled?: boolean;
}

export const Button = styled('button')<IButtonProps>`
  cursor: pointer;
  font-size: 100%;
  font-family: inherit;
  color: ${(props) => (props.filled ? props.theme.primaryAccentTextColor : props.theme.primaryAccentColor)};
  background-color: ${(props) => (props.filled ? props.theme.primaryAccentColor : props.theme.primaryAccentTextColor)};
  border: 0.1rem solid ${(props) => props.theme.primaryAccentColor};
  border-radius: 0.6rem;
  width: 15.5rem;
  padding: 1rem;
  opacity: ${(props) => (props.disabled ? 0.3 : 1)};
`;

export const IconButton = styled('button')`
  background-color: transparent;
  color: white;
  font-size: 100%;
  font-family: inherit;
  border: 0;
  padding: 0 0.6rem;
  margin: 0;
  cursor: ${(props) => (props.disabled ? 'arrow' : 'pointer')};
  opacity: ${(props) => (props.disabled ? '40%' : '100%')};
`;

export const SendIconButton = styled('button')`
  background-color: ${({ theme }) => theme.sendButtonBackgroundColor || theme.primaryAccentColor};
  border-radius: 3rem;
  width: 4.4rem;
  height: 4.4rem;
  color: white;
  padding: 0;
  position: absolute;
  bottom: 4.8rem;
  right: 1.2rem;
  border: none;

  :disabled {
    opacity: 0.3;
  }

  svg {
    position: absolute;
    left: 48%;
    top: 53%;
    transform: translate(-50%, -50%);
  }
`;

interface IFlexContainerProps {
  center?: boolean;
  spaceBetween?: boolean;
  padding?: boolean;
  flexEnd?: boolean;
}

export const FlexContainer = styled('div')<IFlexContainerProps>`
  display: flex;
  ${(props) => (props.center ? 'justify-content: center;' : '')}
  ${(props) => (props.spaceBetween ? 'justify-content: space-between;' : '')}
  ${(props) => (props.padding ? 'padding: 0 1rem;' : '')}
  ${(props) => (props.flexEnd ? 'justify-content: flex-end;' : '')}
`;

export const AgentChatBubble = styled('div')`
  background-color: ${({ theme }) => theme.agentBubbleBackgroundColor || theme.primaryAccentColor} !important;
  border-color: ${({ theme }) => theme.agentBubbleBackgroundColor || theme.primaryAccentColor} !important;
  color: ${({ theme }) => theme.agentBubbleTextColor || theme.primaryAccentTextColor} !important;
`;

export const CustomerChatBubble = styled('div')`
  background-color: ${({ theme }) => theme.bubbleBackgroundColor || '#F1F1F1'} !important;
  border-color: ${({ theme }) => theme.bubbleBackgroundColor || '#F1F1F1'} !important;
  color: ${({ theme }) => theme.bubbleTextColor || 'black'} !important;
`;

export const ChatStatusMessage = styled('div')`
  color: ${({ theme }) => theme.primaryAccentTextColor};
  background-color: ${({ theme }) => theme.primaryAccentColor};
  font-size: 1.2rem;
  padding: 1rem;
  position: relative;
  width: calc(100% - 2rem); /* minus padding */
  left: 0;
`;

export const ChatMessageWarningIcon = styled(ErrorSvg)`
  margin: 1rem;
  margin-right: 0;
  width: 2rem;
  height: 2rem;
  min-width: 2rem;
  min-height: 2rem;
`;

export const UndeliveredNotice = styled('div')`
  color: red;

  p {
    margin: 0;
  }
`;

export const ResendStyled = styled('div')`
  font-weight: 800;
  letter-spacing: 0.1rem;
  cursor: pointer;
  line-height: 1.2rem;
  margin-bottom: 1rem;
`;

export const ReadReceipt = styled('div')`
  font-size: 1rem;
`;

export const ImageAttachment = styled('img')`
  width: 100%;
`;

export const Disclaimer = styled('div')`
  background: white;
  color: gray;
  font-size: 1.2rem;
  left: 0;
  padding: 1rem;
  position: relative;
  width: calc(100% - 2rem); /* minus padding */
`;
